module.exports = __webpack_public_path__ + "img/avatar.411fdf85.png";